import RosterBackendService from './RosterBackendService';
import { GetLocationsResponse, GetLPLItemsResponse, LocationDTO, LPLItemDTO } from '@beable/roster-backend-client-v1';

/*                          LOCATIONS                    */
// Create
async function addNewLocation(location: LocationDTO): Promise<LocationDTO | string | null> {
    const response = await RosterBackendService.createLocation({ data: location });
    if (response.isOk()) {
        return response.value;
    } else {
        if (response.error.statusCode && response.error.statusCode.unsafelyUnwrap() === 503) {
            return 'ISO codes must be unique. This code is already in use.';
        }
        return null;
    }
}

//Read
async function getAllLocations(page: number, parentId?: number): Promise<GetLocationsResponse> {
    const response = await RosterBackendService.getAllLocations(page, parentId);
    if (response.isOk()) {
        return response.value;
    } else {
        return { data: [], pages: 0 };
    }
}

//Update
async function updateLocation(location: LocationDTO): Promise<LocationDTO | string | null> {
    const response = await RosterBackendService.updateLocation({ data: location });
    if (response.isOk()) {
        return response.value;
    } else {
        if (response.error.message.includes('503')) {
            return 'ISO codes must be unique. This code is already in use.';
        }
        return null;
    }
}

//Delete
async function deleteLocation(id: number): Promise<boolean> {
    const response = await RosterBackendService.deleteLocation(id.toString());
    if (response.isOk()) {
        return true;
    } else {
        return false;
    }
}

//Search
async function searchLocations(searchTerm: string): Promise<GetLocationsResponse | null> {
    const response = await RosterBackendService.searchLocations(searchTerm);
    if (response.isOk()) {
        return response.value;
    } else {
        return null;
    }
}

/*                          LOGIN PICK LIST ITEMS                    */
// Create
async function addNewLPLItem(item: LPLItemDTO): Promise<LPLItemDTO | string | null> {
    const response = await RosterBackendService.createLPLItem({ data: item });
    if (response.isOk()) {
        return response.value;
    } else {
        if (response.error.statusCode && response.error.statusCode.unsafelyUnwrap() === 503) {
            return 'Site names and LEAIDs must be unique. The one you have selected is already in use.';
        }
        return null;
    }
}

//Read
async function getLPLItems(page: number): Promise<GetLPLItemsResponse> { //change to the appropriiate csc type later on!
    const response = await RosterBackendService.getLPLItems(page);
    if (response.isOk()) {
        return response.value;
    } else {
        return { data: [], pages: 0 };
    }
}

//Update
async function updateLPLItem(item: LPLItemDTO): Promise<LPLItemDTO | string | null> {
    const response = await RosterBackendService.updateLPLItem({ data: item });
    if (response.isOk()) {
        return response.value;
    } else {
        if (response.error.message.includes('503')) {
            return 'Site names and LEAIDs must be unique. The one you have selected is already in use.'
        }
        return null;
    }
}

//Delete
async function deleteLPLItem(id: string): Promise<boolean> {
    const response = await RosterBackendService.deleteLPLItem(id);
    if (response.isOk()) {
        return response.value;
    } else {
        return false;
    }
}

//Search
async function searchLPLItems(searchTerm: string): Promise<GetLPLItemsResponse | null> {
    try {
        const searchResult = await RosterBackendService.searchLPLItems(searchTerm);
        if (searchResult.isErr()) return null;
        return searchResult.value;
    } catch (error) {
        return null
    }
}

export default {
    addNewLocation, getAllLocations, updateLocation, deleteLocation, searchLocations,
    addNewLPLItem, getLPLItems, updateLPLItem, deleteLPLItem, searchLPLItems
}
